<div #pdfViewerContainer class="ng2-pdf-viewer-container">
  <div class="pdfViewer"></div>
</div>
